;(function ( $, window, document, undefined ){
    'use strict';

    $.notifier = function notifier( message, options ){
        var $backdropID = 'notifier-backdrop';

        if ( $( '#' + $backdropID ).length === 0 ) {
            options = $.extend( {}, $.notifier.options, options );

            var $backdrop = $( '<div/>' )
                .addClass( 'modal-backdrop in' )
                .attr( {
                    tabindex: '-1',
                    id: $backdropID
                } );

            var $notification = $( '<div/>' )
                .addClass( 'notification' )
                .attr( 'role', 'notification' );

            if ( _isString( options.priority ) && _regExp.PRIORITY.test( options.priority ) ) {
                $notification.addClass( 'alert-' + options.priority.toLowerCase() );
            }

            var $title = $( '<h4/>' )
                .append( $.parseHTML( options.title ) );

            var $button = $( '<button/>' )
                .attr( {
                    type: 'button',
                    'data-dismiss': 'notification',
                    'aria-label': 'Close'
                } )
                .addClass( 'close' );

            var $cross = $( '<span/>' )
                .attr( 'aria-hidden', 'true' )
                .html( '&times;' );

            var $message = $( '<p/>' )
                .append( $.parseHTML( message ) );

            var $submit = $( '<button/>' )
                .attr( {
                    type: 'button',
                    'data-dismiss': 'notification',
                    id: 'notifierSubmit',
                    title: options.submit
                } )
                .addClass( 'btn pull-right' )
                .append( options.submit );

            if ( options.showClose === true ) {
                $button.append( $cross );
                $notification.append( $button );
            }

            if ( options.title ) {
                $notification.append( $title );
            }

            if ( message ) {
                $notification.append( $message );
            }

            if ( options.submit ) {
                $notification.append( $submit );

                if ( _isString( options.submit ) && _regExp.PRIORITY.test( options.priority ) ) {
                    $submit.addClass( 'btn-' + options.priority.toLowerCase() );
                }
            }

            var $notifyBox = $( '<div/>' )
                .attr( 'id', 'notifyBox' );

            $notifyBox.prependTo( $( 'body' ) );
            $notification.prependTo( $notifyBox );
            $backdrop.prependTo( $notifyBox ).focus();

            $( "[data-dismiss='notification']" ).one( 'click', function (){
                $notifyBox.remove();
            } );

            $( '#notifierSubmit' ).one( 'click', function (){
                if ( options.callback ) {
                    options.callback();
                }
            } );

            return $notification;
        }
    };

    function _isString( value ){
        return $.type( value ) === 'string' && value.trim().length > 0;
    }

    var _regExp = {
        PRIORITY: /^(?:DANGER|INFO|SUCCESS|WARNING)$/i
    };

    $.notifier.options = {
        title: null,
        showClose: true,
        submit: null,
        priority: 'info',
        callback: null
    };

})( jQuery, window, document );